import { Component, ChangeDetectionStrategy } from '@angular/core';
import { environment } from '@rocksoft/environment';
import { EnvironmentFeatures } from '@rocksoft/shared';
import { DeviceSwappedCurrentActionBarContainerComponent } from './device-swapped-current-action-bar/device-swapped-current-action-bar.container';

@Component({
  selector: 'era-device-swapped-current',
  templateUrl: './device-swapped-current.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DeviceSwappedCurrentActionBarContainerComponent],
})
export class DeviceSwappedCurrentComponent {
  public readonly features: EnvironmentFeatures = environment.features;
}
